export enum NavBarElement {
    Home = "home",
    HealthPlan = "health-plan",
    Diagnostica = "diagnostica",
    Equipe = "equipe",
    Menu = "menu",
    Chat = "chat",
}